"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontPageHeaderNavigation = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../../utils/classFunctions");
const MenuWithInputLink_1 = require("../MenuWithInputLink");
require("./index.scss");
class FrontPageHeaderNavigation extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.generateRoutes = (routeItems, className) => {
            return routeItems.map((route, idx) => {
                const { LinkComponent, linkRoute, subItems, routeKey } = route;
                const SubMenuClassName = 'front-page-header-sub-navigation';
                const itemClasses = (0, classFunctions_1.getClassNames)(`${className}__item`, [
                    subItems ? 'has-subnav' : undefined,
                    this.props.isRouteMatch(linkRoute || '') ? 'active' : undefined,
                ]);
                const LinkComponentWithCloseKeeper = () => (react_1.default.createElement("span", { onClick: MenuWithInputLink_1.closeParentMenuAfterClick },
                    react_1.default.createElement(LinkComponent, null)));
                const routeItemId = `nav-checkbox:${idx}:${routeKey}`;
                return (react_1.default.createElement("li", { key: `scfphn:route:${routeKey}`, className: itemClasses },
                    react_1.default.createElement(LinkComponentWithCloseKeeper, null),
                    subItems && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("input", { type: 'checkbox', id: routeItemId, className: `${className}__nav-checkbox` }),
                        react_1.default.createElement("label", { className: `${className}__arrow`, htmlFor: routeItemId },
                            react_1.default.createElement("i", null)))),
                    subItems ? this.generateMenu(subItems, SubMenuClassName, ['sub-item']) : null));
            });
        };
    }
    generateMenu(routeItems, className, modificators) {
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("ul", { className: classNames }, this.generateRoutes(routeItems, className)));
    }
    render() {
        const { modificators, routeItems } = this.props;
        const className = 'front-page-header-navigation';
        return routeItems ? this.generateMenu(routeItems, className, modificators) : null;
    }
}
exports.FrontPageHeaderNavigation = FrontPageHeaderNavigation;
FrontPageHeaderNavigation.defaultProps = {
    isRouteMatch: () => false,
};
//# sourceMappingURL=index.js.map